module.exports = __webpack_public_path__ + "static/fjar-jolagleði-logo-90b72b7d3fcad33423421e979eca2e21.png";